import { collection, getDocs, orderBy, query } from 'firebase/firestore';
import React, { useEffect, useState } from 'react'
import { db } from '../../firebaseConfig/firebase';
import { Link } from 'react-router-dom';

const CategoriesCards = () => {
    const [categories, setCategories] = useState([])

    const getCategories = async () => {
        const myQuery = query(collection(db, "categories"), orderBy("name", "asc"));
        const myDocs = await getDocs(myQuery)
        if (myDocs.docs.length > 0) {
            setCategories(myDocs.docs)
        }
    }

    useEffect(() => {
        getCategories()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div className='container'>
            <div className='row'>
                {
                    categories.map((category) => (
                        <div key={category.id} className='col-6'>
                            <Link to={`/ProductsByCategory/${category.data().name}`} className='card mb-3' style={{ textDecoration: 'none' }}>
                                <div className="card-body d-flex justify-content-center align-items-center" style={{height:"100px"}}>
                                    <h6 className="card-text text-info">{category.data().name}</h6>
                                </div>
                            </Link>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default CategoriesCards